import { useCallback } from 'react';
import { useFetch } from './use-fetch';
import { fetchBookingDetails } from '../utils/api';
import { type Shop, type AppointmentSlot, type PersonalInfo } from '../models/repair-bookings';

type UseBookingResult = {
    confirmationId: string;
    shop: Shop | null;
    slot: AppointmentSlot | null;
    personalInfo: PersonalInfo | null;
    error: Error | null;
    loading: boolean;
};

const useBooking = (csrfToken: string, bookingToken: string): UseBookingResult => {
    const fetcher = useCallback(() => {
        return fetchBookingDetails(csrfToken, bookingToken);
    }, [csrfToken, bookingToken]);
    const { data, error, loading } = useFetch(fetcher);

    return {
        confirmationId: data?.confirmation_id ?? '',
        shop: data?.shop ?? null,
        slot: data?.slot ?? null,
        personalInfo: data?.customer ?? null,
        error,
        loading,
    };
};

export default useBooking;
